import React from "react";
import { Box, Typography } from "@mui/material";
import HomeButton from "../../Components/NotFound/HomeButton";

const NotFoundPage = () => {
  return (
    <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: "120px",
            fontWeight: "bold",
            color: "#14b8a6",
            margin: 0,
            lineHeight: 1,
          }}
        >
          404
        </Typography>
        <Typography
          variant="h2"
          sx={{
            fontSize: "48px",
            fontWeight: "600",
            color: "white",
            marginTop: "20px",
            marginBottom: "10px",
          }}
        >
          Oops! Something Went Wrong
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: "18px",
            color: "#999999",
            marginBottom: "30px",
            maxWidth: "600px",
          }}
        >
          We couldn't find the page you're looking for. It might have been moved
          or deleted. Don't worry, you can return to the home page and continue
          from there.
        </Typography>
        <HomeButton />
      </Box>
  );
};

export default NotFoundPage;
